<template>
  <b-modal :id="id" dialog-class="modal-lg" @shown="shown" no-close-on-backdrop>
    <template slot="modal-header">
      <span>社團活動成果報告書</span>
      <b-button class="close" @click="cancel">
        <b-icon-x></b-icon-x>
      </b-button>
    </template>
    <div class="alert alert-warning" role="alert">
      1.實際支出金額(見活動經費支出明細表)<br />
      2.經費執行率(實際支出金額/預算金額)<br />
      3.若「活動經費支出明細表」總金額大於0，則基本資料之「學校經費補助核定核銷金額」不應等於0<br />
    </div>
    <div role="tablist">
      <b-button class="mb-1" block v-b-toggle.accordion-1>基本資料</b-button>
      <b-collapse
        id="accordion-1"
        visible
        accordion="my-accordion"
        role="tabpanel"
      >
        <div class="card mb-1">
          <div class="card-body row">
            <div class="col-md-4 col-sm-12">
              <form-input
                v-model="vm.SYear"
                id="SYear"
                label="學年度"
                type="number"
              ></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
              <form-select v-model="vm.Semester" id="Semester" label="學期">
                <div is="option" value="u">上</div>
                <div is="option" value="d">下</div>
              </form-select>
            </div>
            <div class="col-md-4 col-sm-12">
              <form-input
                v-model="vm.No"
                id="No"
                label="活動編號"
                type="text"
                disabled
              ></form-input>
            </div>
            <div class="col-12">
              <form-input
                v-model="vm.Name"
                id="Name"
                label="活動名稱"
                type="text"
                disabled
              ></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            活動時間
          </div>
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <form-date-input
                v-model="vm.StartDay"
                id="StartDay"
                label="日期(起)"
                disabled
              ></form-date-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.StartTime"
                id="StartTime"
                label="時間(起)"
                type="time"
                disabled
              ></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-date-input
                v-model="vm.EndDay"
                id="EndDay"
                label="日期(訖)"
                disabled
              ></form-date-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.EndTime"
                id="EndTime"
                label="時間(訖)"
                type="time"
                disabled
              ></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            活動地點
          </div>
          <div class="card-body row">
            <div class="col-md-1 col-sm-12">
              <div class="form-group">
                <label>校內</label>
                <label class="form-control">
                  <input
                    type="checkbox"
                    v-model="vm.OnCampus"
                    true-value="true"
                    disabled
                  />
                </label>
              </div>
            </div>
            <div class="col-md-11 col-sm-12">
              <form-input
                v-model="vm.Place"
                id="Place"
                label="地點"
                type="text"
                disabled
              ></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            活動人數
          </div>
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.Internals"
                id="Internals"
                label="本校人數"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.Outsiders"
                id="Outsiders"
                label="外校人數"
                type="number"
                disabled
              ></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            辦理社團
          </div>
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <form-select
                v-model="vm.CommunityID"
                id="CommunityID"
                label="社團名稱"
                disabled
              >
                <div is="option" value="">請選擇</div>
                <div
                  is="option"
                  v-for="item in Communitys"
                  :key="item.key"
                  :value="item.key"
                >
                  {{ item.value }}
                </div>
              </form-select>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.StudentNo"
                id="StudentNo"
                label="負責人學號"
                type="text"
                student
                disabled
              ></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.StudentName"
                id="StudentName"
                label="負責人姓名"
                type="text"
                disabled
              ></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-select v-model="vm.ClassID" label="負責人班級" disabled>
                <div
                  is="option"
                  v-for="o in classList"
                  :key="o.key"
                  :value="o.key"
                >
                  {{ o.value }}
                </div>
              </form-select>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.Phone"
                id="Phone"
                label="負責人連絡電話"
                type="tel"
                disabled
              ></form-input>
            </div>
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.Email"
                id="Email"
                label="負責人聯絡信箱"
                type="email"
                disabled
              ></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            經費支出
          </div>
          <div class="card-body row">
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.Budget"
                id="Budget"
                label="預算金額"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.BudgetPaid"
                id="BudgetPaid"
                label="實際支出金額"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.BudgetRate"
                id="BudgetRate"
                label="經費執行率(%)"
                disabled
              ></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.SchoolPaid"
                id="SchoolPaid"
                label="學校經費補助核定核銷金額"
                type="number"
                required
              ></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            整體滿意度
          </div>
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <form-input
                v-model="vm.TotalScore"
                id="TotalScore"
                label="整體滿意度分數(%)"
                type="number"
                disabled
              ></form-input>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-2
        >核心能力(軟實力)</b-button
      >
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-header">
            統計表
          </div>
          <div class="card-body row">
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.CenterAbilityScore1"
                id="CenterAbilityScore1"
                label="溝通表達"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.CenterAbilityScore2"
                id="CenterAbilityScore2"
                label="持續學習"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.CenterAbilityScore3"
                id="CenterAbilityScore3"
                label="情緒管理"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.CenterAbilityScore4"
                id="CenterAbilityScore4"
                label="人際互動"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.CenterAbilityScore5"
                id="CenterAbilityScore5"
                label="團隊合作"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.CenterAbilityScore6"
                id="CenterAbilityScore6"
                label="問題解決"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.CenterAbilityScore7"
                id="CenterAbilityScore7"
                label="積極創新"
                type="number"
                disabled
              ></form-input>
            </div>
            <div class="col-md-3 col-sm-12">
              <form-input
                v-model="vm.CenterAbilityScore8"
                id="CenterAbilityScore8"
                label="紀律責任"
                type="number"
                disabled
              ></form-input>
            </div>
          </div>
        </div>

        <div class="card mb-1">
          <div class="card-header">
            統計圖
          </div>
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <label>圖一</label>
              <div v-for="f in vm.Files" :key="f">
                <a
                  :href="Path + f"
                  target="_blank"
                  v-if="f.includes('核心能力圖一')"
                  >{{ f }}</a
                >
              </div>
              <form-textarea
                v-model="vm.CenterAbilityPic1Desc"
                id="CenterAbilityPic1Desc"
                label="圖一說明"
                disabled
              ></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>圖二</label>
              <div v-for="f in vm.Files" :key="f">
                <a
                  :href="Path + f"
                  target="_blank"
                  v-if="f.includes('核心能力圖二')"
                  >{{ f }}</a
                >
              </div>
              <form-textarea
                v-model="vm.CenterAbilityPic2Desc"
                id="CenterAbilityPic2Desc"
                label="圖二說明"
                disabled
              ></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>圖三</label>
              <div v-for="f in vm.Files" :key="f">
                <a
                  :href="Path + f"
                  target="_blank"
                  v-if="f.includes('核心能力圖三')"
                  >{{ f }}</a
                >
              </div>
              <form-textarea
                v-model="vm.CenterAbilityPic3Desc"
                id="CenterAbilityPic3Desc"
                label="圖三說明"
                disabled
              ></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>圖四</label>
              <div v-for="f in vm.Files" :key="f">
                <a
                  :href="Path + f"
                  target="_blank"
                  v-if="f.includes('核心能力圖四')"
                  >{{ f }}</a
                >
              </div>
              <form-textarea
                v-model="vm.CenterAbilityPic4Desc"
                id="CenterAbilityPic4Desc"
                label="圖四說明"
                disabled
              ></form-textarea>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-3
        >活動滿意度分析圖</b-button
      >
      <b-collapse id="accordion-3" accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-body row">
            <div class="col-12">
              <label>圖一</label>
              <div v-for="f in vm.Files" :key="f">
                <a
                  :href="Path + f"
                  target="_blank"
                  v-if="f.includes('活動滿意度分析圖一')"
                  >{{ f }}</a
                >
              </div>
              <form-textarea
                v-model="vm.SatisfactionPic1Desc"
                id="SatisfactionPic1Desc"
                label="圖一說明"
                disabled
              ></form-textarea>
            </div>
            <div class="col-12">
              <label>圖二</label>
              <div v-for="f in vm.Files" :key="f">
                <a
                  :href="Path + f"
                  target="_blank"
                  v-if="f.includes('活動滿意度分析圖二')"
                  >{{ f }}</a
                >
              </div>
              <form-textarea
                v-model="vm.SatisfactionPic2Desc"
                id="SatisfactionPic2Desc"
                label="圖二說明"
                disabled
              ></form-textarea>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-4
        >活動照片剪影(至少四張)</b-button
      >
      <b-collapse id="accordion-4" accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-body row">
            <div class="col-md-6 col-sm-12">
              <label>圖一</label>
              <div v-for="f in vm.Files" :key="f">
                <a
                  :href="Path + f"
                  target="_blank"
                  v-if="f.includes('活動照片剪影圖一')"
                  >{{ f }}</a
                >
              </div>
              <form-textarea
                v-model="vm.ActivityPic1Desc"
                id="ActivityPic1Desc"
                label="圖一說明"
                disabled
              ></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>圖二</label>
              <div v-for="f in vm.Files" :key="f">
                <a
                  :href="Path + f"
                  target="_blank"
                  v-if="f.includes('活動照片剪影圖二')"
                  >{{ f }}</a
                >
              </div>
              <form-textarea
                v-model="vm.ActivityPic2Desc"
                id="ActivityPic2Desc"
                label="圖二說明"
                disabled
              ></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>圖三</label>
              <div v-for="f in vm.Files" :key="f">
                <a
                  :href="Path + f"
                  target="_blank"
                  v-if="f.includes('活動照片剪影圖三')"
                  >{{ f }}</a
                >
              </div>
              <form-textarea
                v-model="vm.ActivityPic3Desc"
                id="ActivityPic3Desc"
                label="圖三說明"
                disabled
              ></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>圖四</label>
              <div v-for="f in vm.Files" :key="f">
                <a
                  :href="Path + f"
                  target="_blank"
                  v-if="f.includes('活動照片剪影圖四')"
                  >{{ f }}</a
                >
              </div>
              <form-textarea
                v-model="vm.ActivityPic4Desc"
                id="ActivityPic4Desc"
                label="圖四說明"
                disabled
              ></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>圖五</label>
              <div v-for="f in vm.Files" :key="f">
                <a
                  :href="Path + f"
                  target="_blank"
                  v-if="f.includes('活動照片剪影圖五')"
                  >{{ f }}</a
                >
              </div>
              <form-textarea
                v-model="vm.ActivityPic5Desc"
                id="ActivityPic5Desc"
                label="圖五說明"
                disabled
              ></form-textarea>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>圖六</label>
              <div v-for="f in vm.Files" :key="f">
                <a
                  :href="Path + f"
                  target="_blank"
                  v-if="f.includes('活動照片剪影圖六')"
                  >{{ f }}</a
                >
              </div>
              <form-textarea
                v-model="vm.ActivityPic6Desc"
                id="ActivityPic6Desc"
                label="圖六說明"
                disabled
              ></form-textarea>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-5
        >活動建議事項與檢討反饋</b-button
      >
      <b-collapse id="accordion-5" accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-body row">
            <div class="col-12">
              <form-textarea
                v-model="vm.Feedback"
                id="Feedback"
                label="活動建議事項與檢討反饋"
                disabled
              ></form-textarea>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-6
        >活動自評與心得感想</b-button
      >
      <b-collapse id="accordion-6" accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-body row">
            <div class="col-12">
              <form-textarea
                v-model="vm.Experience"
                id="Experience"
                label="活動自評與心得感想"
                disabled
              ></form-textarea>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-7
        >發票單據憑證影本</b-button
      >
      <b-collapse id="accordion-7" accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-body row">
            <div class="col-12">
              <label>發票單據憑證</label>
              <div v-for="f in vm.Files" :key="f">
                <a
                  :href="Path + f"
                  target="_blank"
                  v-if="f.includes('發票單據憑證影本')"
                  >{{ f }}</a
                >
              </div>
              <form-textarea
                v-model="vm.BillPic1Desc"
                id="BillPic1Desc"
                label="註記"
                disabled
              ></form-textarea>
            </div>
          </div>
        </div>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-8 @click="show8"
        >報到</b-button
      >
      <b-collapse id="accordion-8" accordion="my-accordion" role="tabpanel">
        <div class="card mb-1">
          <div class="card-body">
            <file-upload
              :url="
                '/api/activityregister/ExcelCommunityActivityApplication?no=' +
                  vm.No +
                  '&id=' +
                  vm.CommunityActivityApplicationID
              "
              @ok="ok8"
            ></file-upload>
          </div>
          <div class="card-footer">
            <a href="/template/activityregister.xlsx" class="btn btn-default"
              ><b-icon-arrow-down></b-icon-arrow-down>範本下載</a
            >
          </div>
        </div>
        <table class="table">
          <thead>
            <tr>
              <th>學號/教師編號</th>
              <th>姓名</th>
              <th></th>
            </tr>
          </thead>
          <tr
            v-for="item in tempTableData.value"
            :key="item.ActivityRegisterID"
          >
            <td>{{ item.UserNo }}</td>
            <th>{{ item.Name }}</th>
            <th>
              <b-button variant="danger" @click="del8(item.ActivityRegisterID)"
                >刪除</b-button
              >
            </th>
          </tr>
          <tr>
            <td data-th="學號/教師編號">
              <input v-model="temp.UserNo" type="text" class="form-control" />
            </td>
            <td data-th="姓名">
              <input v-model="temp.Name" type="text" class="form-control" />
            </td>
            <td>
              <div class="form-group">
                <b-button variant="primary" @click="save8">儲存</b-button>
              </div>
            </td>
          </tr>
        </table>

        <pagination
          v-model="pager"
          :rows="tempTableData.count"
          :rowperpage="10"
          @paging="load"
        ></pagination>
      </b-collapse>

      <b-button class="mb-1" block v-b-toggle.accordion-9 @click="show9"
        >活動經費支出明細表</b-button
      >
      <b-collapse id="accordion-9" accordion="my-accordion" role="tabpanel">
        <table class="table">
          <thead>
            <tr>
              <th>項次</th>
              <th>支出項目</th>
              <th>用途說明</th>
              <th>單位</th>
              <th>單價</th>
              <th>數量</th>
              <th>總額</th>
              <th>備註</th>
            </tr>
          </thead>
          <tr
            v-for="(item, index) in budgetTableData.value"
            :key="item.CommunityActivityReportBudgetID"
          >
            <td>{{ index + 1 }}</td>
            <td>{{ item.Name }}</td>
            <th>{{ item.Purpose }}</th>
            <th>{{ item.Unit }}</th>
            <th>{{ item.Price }}</th>
            <th>{{ item.Quantity }}</th>
            <th>{{ item.Total }}</th>
            <th>{{ item.Remark }}</th>
          </tr>
        </table>

        <div class="col-12 text-right font-weight-bold">
          <p>
            <u>總計：{{ budgetTotal }}</u>
          </p>
        </div>
        <pagination
          v-model="pager"
          :rows="budgetTableData.count"
          :rowperpage="10"
          @paging="load"
        ></pagination>
      </b-collapse>
    </div>
    <template slot="modal-footer">
      <div class="col-12">
        <form-input
          v-model="vm.Suggestion"
          id="Suggestion"
          label="建議(通過後清除內容)"
        ></form-input>
      </div>
      <b-button variant="danger" @click="back" v-if="isEdit"
        ><b-icon-arrow-counterclockwise></b-icon-arrow-counterclockwise
        >退回</b-button
      >
      <b-button variant="primary" @click="pass" v-if="isEdit"
        ><b-icon-check2></b-icon-check2>通過</b-button
      >
      <b-button variant="secondary" @click="cancel"
        ><b-icon-x></b-icon-x>關閉</b-button
      >
    </template>
  </b-modal>
</template>

<script>
import { detail } from "@/views";
export default detail({
  name: "communityactivityreportDetail",
  api: "/api/communityactivityreportreview/",
  data: {
    classList: [],
    Communitys: [],
    budgetTableData: { count: 0, value: [] },
    budgetTotal: 0,
    pager: {},
    vm: { Files: [] },
    temp: {
      No: null,
      UserNo: "",
      Name: "",
      CommunityActivityApplicationID: null,
    },
    tempTableData: { count: 0, value: [] },
  },
  created: function() {
    this.$parameter.community().then((res) => {
      this.Communitys = res.data;
    });
    this.$parameter.class("", "", "", "", "").then((res) => {
      this.classList = res.data.Class;
    });
  },
  computed: {
    Path: function() {
      return this.$apiurl + this.vm.Dir;
    },
    isEdit: function() {
      return this.vm.Approved == "W";
    },
  },
  methods: {
    load: function() {
      return this.$http({
        method: "get",
        url:
          "api/communityactivityreportbudget/Get?id=" +
          this.vm.CommunityActivityReportID,
        headers: this.pager,
      }).then((res) => {
        if (res.data) {
          this.budgetTableData.count = res.data.count;
          this.budgetTableData.value = res.data.value;
          this.budgetTotal = this.budgetTableData.value.reduce(
            (acc, item) => acc + item.Total,
            0
          );
        } else {
          this.budgetTableData.count = 0;
          this.budgetTableData.value = [];
        }
      });
    },
    reload: function() {
      this.pager.skip = 0;
      return this.load();
    },
    show9: function() {
      this.reload();
    },
    pass: function() {
      this.saveing = true;

      this.$http({
        method: "post",
        url: "api/communityactivityreportreview/Pass",
        data: this.vm,
      })
        .then(() => {
          this.$bvToast.toast("審核通過", {
            title: "",
            variant: "success",
            solid: true,
          });
          this.$emit("reload");
          this.$bvModal.hide(this.id);
        })
        .finally(() => (this.saveing = false));
    },
    back: function() {
      if (!this.vm.Suggestion) {
        this.$bvToast.toast("請填寫建議", {
          title: "",
          variant: "danger",
          solid: true,
        });
      } else {
        this.saveing = true;

        this.$http({
          method: "post",
          url: "api/communityactivityreportreview/Back",
          data: this.vm,
        })
          .then(() => {
            this.$bvToast.toast("已退回", {
              title: "",
              variant: "success",
              solid: true,
            });
            this.$emit("reload");
            this.$bvModal.hide(this.id);
          })
          .finally(() => (this.saveing = false));
      }
    },
    show8: function() {
      this.reload8();
    },
    save8: function() {
      this.temp.No = 0;
      this.temp.CommunityActivityApplicationID = this.vm.CommunityActivityApplicationID;
      this.$http({
        method: "put",
        url: "api/activityregister/PutCommunityActivityApplication",
        data: this.temp,
      }).then(() => {
        this.reload8();
      });
    },
    del8: function(ActivityRegisterID) {
      this.$http({
        method: "delete",
        url:
          "api/activityregister/DeleteCommunityActivityApplication/" +
          ActivityRegisterID,
      }).then(() => {
        this.reload8();
      });
    },
    load8: function() {
      return this.$http({
        method: "get",
        url:
          "api/activityregister/GetCommunityActivityApplication?id=" +
          this.vm.CommunityActivityApplicationID,
        headers: this.pager,
      }).then((res) => {
        if (res.data) {
          this.tempTableData.count = res.data.count;
          this.tempTableData.value = res.data.value;
        } else {
          this.tempTableData.count = 0;
          this.tempTableData.value = [];
        }
      });
    },
    reload8: function() {
      this.pager.skip = 0;
      return this.load8();
    },
    ok8: function(e) {
      this.$bvToast.toast(
        "上傳" + e.res.data.totel + " 新增" + e.res.data.success,
        { title: "上傳完成", variant: "success", solid: true }
      );
      this.load8();
    },
  },
});
</script>

<style></style>
